// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:32:36.146Z
// Property: Scissortail Crossing (ID: 6767906449167051)
// Collections: 36 amenities, 6 floorplans (live), 48 photos, 22 POIs, 2 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449167051",
  "property_external_id": "478203",
  "property_zillow_url": "https://www.zillow.com/apartments/broken-arrow-ok/scissortail-crossing/B8Wtfh/",
  "property_apartments_url": "https://www.apartments.com/2800-n-23rd-st-broken-arrow-ok-unit-501291674/7sh8kyy/",
  "property_google_business_url": "https://www.google.com/maps/place/Scissortail+Crossing+Apartments/data=!4m2!3m1!1s0x0:0xd274bc92211c27f2?sa=X&ved=2ahUKEwj59-m3ioOTAxUWv4kEHdfsMr4Q_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "scissortail-crossing",
  "property_name": "Scissortail Crossing",
  "property_website_url": "https://www.caseusa.com/apartments/ok/broken-arrow/scissortail-crossing/",
  "property_domain": null,
  "property_address": "2800 North 23rd Street",
  "property_full_address": "2800 North 23rd Street, Broken Arrow, OK, 74014",
  "property_address_1": "2800 North 23rd Street",
  "property_address_2": null,
  "property_address_city": "Broken Arrow",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "74014",
  "property_address_country": "US",
  "property_address_county": "Wagoner County",
  "property_neighborhood_address": null,
  "property_address_latitude": "36.0798",
  "property_address_longitude": "-95.761",
  "property_email": "scissortail@caseusa.com",
  "property_phone": "(918) 246-6518",
  "property_call_tracking_phone": "855-507-1385",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Scissortail Crossing in Broken Arrow, OK, where contemporary elegance meets comfort. Choose from our thoughtfully designed one- and two-bedroom floor plans, and enjoy resort-style amenities like a poolside grill area, fitness center, and tranquil courtyards with pet stations. Your perfect home awaits—schedule your tour today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Scissortail Crossing, your ultimate apartment community in the heart of Broken Arrow, OK. Our diverse floor plans, featuring one and two-bedroom apartments, cater to a variety of lifestyles and preferences. Experience the perfect blend of comfort and modern living, enhanced by our exceptional array of amenities designed to elevate your everyday experience.\n\nAt Scissortail Crossing, you can unwind in our resort-style pool with a charming cabana or enjoy grilling and chilling at our BBQ and picnic area. Stay active in our 24-hour fitness center or socialize in our resident clubhouse complete with an internet café serving gourmet coffee. For pet lovers, our community offers spacious courtyards with pet stations and an onsite dog park, ensuring your furry friends feel right at home.\n\nEach apartment boasts modern finishes and conveniences, including stainless-steel appliances, wall-to-wall carpeting, and large closets. Unwind on your private patio or balcony*, or cozy up next to your fireplace*. With features like reliable cell reception and preinstalled WiFi powered by Cox, staying connected has never been easier.\n\nAdditional amenities include 24/7 onsite maintenance, flexible payment options, and limited access gates, offering peace of mind and convenience. Whether you prefer designer colors or loft-style living, our apartments provide an inviting atmosphere tailored for your needs.\n\nDiscover your new home at Scissortail Crossing today! Browse our availability or schedule a tour to experience our vibrant community firsthand. Your perfect apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019cfb54-d888-74e1-9149-398aed96e9b3.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor grilling area with picnic tables and a stone fireplace.",
    "public_id": "019cfb54-d888-74e1-9149-398aed96e9b3",
    "storage_key": "property/6767906449167051/019cfb54-d888-74e1-9149-398aed96e9b3.webp",
    "width": 2700,
    "height": 1800
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": null,
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": "10",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Maximum of two pets allowed (cats and dogs). Breed restrictions apply.",
  "property_pet_policy_description": "No weight limit. Maximum of two pets allowed (cats and dogs). Breed restrictions apply. Pet rent: $30 per pet per month. One-time fee: $500 per pet (non-refundable).",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://scissortailcrossingapartmentsbrokenarrow.securecafe.com/onlineleasing/scissortail-crossing/floorplans.aspx",
  "property_resident_portal_url": "https://scissortailcrossingapartmentsbrokenarrow.securecafe.com/residentservices/scissortail-crossing/userlogin.aspx",
  "property_apply_now_url": "https://scissortailcrossingapartmentsbrokenarrow.securecafe.com/onlineleasing/scissortail-crossing/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019cfb54-0543-720a-803e-ccaa2333a3b3.webp",
  "property_primary_logo_media": {
    "alt_text": "Scissortail Crossing logo",
    "public_id": "019cfb54-0543-720a-803e-ccaa2333a3b3",
    "storage_key": "property/6767906449167051/019cfb54-0543-720a-803e-ccaa2333a3b3.webp",
    "width": 2560,
    "height": 1369
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019cfb54-eda6-778c-9cc0-38fb2d872749.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Scissortail Crossing logo with a bird in a circle above the text.",
    "public_id": "019cfb54-eda6-778c-9cc0-38fb2d872749",
    "storage_key": "property/6767906449167051/019cfb54-eda6-778c-9cc0-38fb2d872749.webp",
    "width": 640,
    "height": 342
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019cfb55-0327-714b-ab08-1e8a3a68e433.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Scissortail Crossing logo",
    "public_id": "019cfb55-0327-714b-ab08-1e8a3a68e433",
    "storage_key": "property/6767906449167051/019cfb55-0327-714b-ab08-1e8a3a68e433.webp",
    "width": 640,
    "height": 342
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#324d58",
  "property_secondary_color": "#3d3d3f",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#eae0c8",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "789 - 1267",
  "property_sqft_min": "789",
  "property_sqft_max": "1267",
  "property_price_range": "1144 - 1694",
  "property_price_min": "1144",
  "property_price_max": "1694",
  "property_available_units": 10,
  "property_facebook_url": "https://www.facebook.com/ScissortailBA/posts/1325034149622933/",
  "property_instagram_url": "https://www.instagram.com/scissortailcrossingapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJEb2BO1iKtocR8iccIZK8dNI",
  "property_youtube_url": "https://www.youtube.com/watch?v=9d2TCZQZycA",
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartment+Complex&find_loc=Broken+Arrow%2C+OK",
  "property_tiktok_url": "https://www.tiktok.com/@scissortailapts",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Scissortail Crossing",
  "property_home_romance_title": "Embrace the Joy of Living at Our Vibrant Community",
  "property_home_amenities_blurb": "At Scissortail Crossing in Broken Arrow, OK, modern living blends effortlessly with enriching amenities. Indulge in our resort-style pool, unwind by the cozy fireplace, or relish BBQs by the picnic area. With pet-friendly spaces and thoughtfully designed floor plans, your perfect home awaits—where comfort meets community.",
  "property_home_floorplans_blurb": "Welcome to Scissortail Crossing in Broken Arrow, OK, where modern living meets comfort and style. Our thoughtfully designed floor plans cater to your needs, blending elegance with functionality. Uncover your ideal apartment home today and elevate your lifestyle in a vibrant community that feels just like home.",
  "property_home_gallery_blurb": "At Scissortail Crossing in Broken Arrow, OK, your ideal home awaits. Choose from stylish one- and two-bedroom floor plans featuring stainless-steel appliances and cozy fireplaces. Savor leisure with our resort-style pool, pet-friendly spaces, and a lively clubhouse. Picture yourself unwinding here—your vibrant lifestyle starts now!",
  "property_home_neighborhood_blurb": "At Scissortail Crossing in Broken Arrow, OK, your vibrant lifestyle awaits amidst a tapestry of local treasures. Enjoy access to lush parks like Rhema and Nienhuis, enriching experiences at Martin Regional Library, and the excitement of Tiger Memorial Stadium—all just moments from your one or two-bedroom sanctuary. Uncover the possibilities today!",
  "property_home_reviews_blurb": "At Scissortail Crossing in Broken Arrow, OK, residents rave about the vibrant community spirit, stating, \"It's not just a place to live; it feels like home.\" Join us to experience the friendly atmosphere and exceptional amenities. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At Scissortail Crossing in Broken Arrow, OK, vibrant living meets convenience. Unwind at Nienhuis Park, shop at Lowe's or The Home Depot, and indulge your interests at The Museum Broken Arrow. Embrace a lifestyle where community amenities and local treasures harmoniously intertwine. See what's around our community and explore local favorites!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Scissortail Crossing in Broken Arrow, OK, enjoy the perfect blend of luxury and comfort. From our resort-style pool with a cabana to the 24-hour fitness center and pet-friendly courtyards, every corner invites relaxation. Experience contemporary living with designer finishes and convenient amenities that cater to your lifestyle.",
  "property_applynow_blurb": "At Scissortail Crossing in Broken Arrow, OK, experience luxurious living with versatile floor plans, including spacious one and two-bedroom options. Enjoy resort-style amenities like a stunning pool, dog park, and an inviting resident clubhouse. Embrace comfort and convenience—find your new home and lease online today!",
  "property_contactus_blurb": "At Scissortail Crossing in Broken Arrow, OK, we offer a collection of thoughtfully designed one and two-bedroom floor plans tailored for your lifestyle. Whether you seek cozy privacy or spacious living, we have the perfect apartment waiting for you. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At Scissortail Crossing in Broken Arrow, OK, our thoughtfully designed one and two-bedroom floor plans cater to diverse lifestyles. Have questions? Our FAQs page is your go-to resource for insights about our vibrant community and amenities. Let us help you make informed decisions about your future home!",
  "property_floorplans_blurb": "At Scissortail Crossing in Broken Arrow, OK, our thoughtfully designed floor plans cater to your lifestyle. From cozy one-bedroom retreats to spacious two-bedroom homes, each layout reflects modern comfort and style. Browse our available apartment options to find the perfect fit that meets your needs and enhances your living experience.",
  "property_gallery_blurb": "At Scissortail Crossing in Broken Arrow, OK, life unfolds between the comforts of home and vibrant community amenities. From spacious one and two-bedroom floor plans to our resort-style pool and grill areas, picture yourself enjoying picturesque courtyards, 24-hour fitness, and a welcoming vibe that’s truly one-of-a-kind!",
  "property_interactivemap_blurb": "At Scissortail Crossing in Broken Arrow, OK, your ideal apartment awaits! Choose from our one and two-bedroom floor plans, designed for comfort with stainless-steel appliances and cozy fireplaces. Relish resort-style amenities, including a poolside grill and pet-friendly courtyards. Check out our interactive community map to find your perfect home today!",
  "property_pets_blurb": "Nestled in the heart of Broken Arrow, Scissortail Crossing invites you to enjoy spacious living with no weight limits for your furry friends. With a vibrant community and lush green spaces, your pets will thrive here. Experience the perfect blend of comfort and style in your new home, where pets are cherished!",
  "property_referafriend_blurb": "At Scissortail Crossing in Broken Arrow, OK, we celebrate community and connection. With charming one and two-bedroom floor plans, your perfect home awaits. Great friends make great neighbors—invite a friend to join our vibrant community today and elevate your lifestyle together! Experience the Scissortail difference!",
  "property_residentaccess_blurb": "Welcome to Scissortail Crossing in Broken Arrow, OK, where comfort meets convenience. Choose from our spacious one and two-bedroom floor plans that cater to your lifestyle. Log in to your resident portal to effortlessly pay rent, schedule maintenance, and access exclusive community perks tailored just for you.",
  "property_reviews_blurb": "At Scissortail Crossing in Broken Arrow, OK, residents rave about their experience, highlighting the \"friendly staff and spacious layouts.\" Our community fosters a welcoming atmosphere, making it a perfect place to call home. Curious about life here? See what our residents have to say about living at our community!",
  "property_created_at": "1770834019642",
  "property_scheduletour_blurb": "At Scissortail Crossing in Broken Arrow, OK, our thoughtfully designed one- and two-bedroom floor plans offer the perfect blend of comfort and style. Schedule a tour today and hear firsthand from our residents about why they love calling this vibrant community home! Your ideal living space awaits.",
  "property_thankyou_blurb": "Thank you for reaching out to Scissortail Crossing in Broken Arrow, OK! Our charming one and two-bedroom floor plans offer the perfect blend of comfort and style. A member of our team will connect with you soon to help you discover your new home. Exciting possibilities await!",
  "property_virtualtours_blurb": "At Scissortail Crossing in Broken Arrow, OK, elegant one and two-bedroom apartments await your discovery. Embrace a community designed for comfort and style. Step inside from the comfort of your home—take a virtual tour today and envision your new life in a space uniquely yours!",
  "property_copyright": "2026 All Rights Reserved. Scissortail Crossing",
  "property_seo_title_home": "Scissortail Crossing |  Apartments in Broken Arrow, OK",
  "property_seo_description_home": "Welcome to Scissortail Crossing in Broken Arrow, OK—where luxury meets comfort! Enjoy resort-style amenities, spacious floor plans, and a vibrant community.",
  "property_seo_title_floorplans": "Floor Plans | Broken Arrow, OK Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Scissortail Crossing in Broken Arrow, OK. Choose from stylish one- or two-bedroom floor plans tailored to your lifestyle.",
  "property_seo_title_amenities": "Amenities | Broken Arrow, OK Apartments for Rent",
  "property_seo_description_amenities": "Experience ultimate comfort at Scissortail Crossing in Broken Arrow, OK! Enjoy resort-style living with a pool, BBQ areas, dog park, and modern apartments.",
  "property_seo_title_gallery": "Gallery | Apartments in Broken Arrow, OK",
  "property_seo_description_gallery": "Experience luxury at Scissortail Crossing, Broken Arrow, OK. Modern amenities, stunning floor plans, and a vibrant community await your new home!",
  "property_seo_title_virtualtours": "Virtual Tours | Scissortail Crossing Apartments",
  "property_seo_description_virtualtours": "Experience Scissortail Crossing in Broken Arrow, OK! Take a virtual tour to see our inviting one and two-bedroom apartments designed for modern living.",
  "property_seo_title_interactivemap": "Interactive Map | Scissortail Crossing Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Scissortail Crossing in Broken Arrow, OK! Explore our interactive map for one and two-bedroom apartments with great amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Broken Arrow, OK",
  "property_seo_description_neighborhood": "Uncover the charm of Broken Arrow, OK at Scissortail Crossing. Check out local favorites and vibrant attractions just steps from your new home.",
  "property_seo_title_contact": "Contact Us | Scissortail Crossing",
  "property_seo_description_contact": "Connect with Scissortail Crossing in Broken Arrow, OK! Our leasing team is ready to answer your questions about our spacious one and two-bedroom floor plans.",
  "property_seo_title_faqs": "FAQs | Apartments in Broken Arrow, OK",
  "property_seo_description_faqs": "Uncover answers to your inquiries at Scissortail Crossing! From luxurious amenities to flexible living options—everything you need is just a click away.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Broken Arrow, OK",
  "property_seo_description_reviews": "At Scissortail Crossing in Broken Arrow, OK, hear from our residents about the vibrant community, luxury amenities, and lifestyle that awaits you!",
  "property_seo_title_applynow": "Apply Now | Apartments in Broken Arrow, OK",
  "property_seo_description_applynow": "Discover modern living at Scissortail Crossing, Broken Arrow, OK! Enjoy resort-style amenities and pet-friendly spaces. Apply online now!",
  "property_seo_title_residentaccess": "Resident Access | Scissortail Crossing",
  "property_seo_description_residentaccess": "Experience convenience at Scissortail Crossing! Log in to your resident portal for seamless rent payments and maintenance requests in Broken Arrow.",
  "property_seo_title_referafriend": "Refer A Friend | Scissortail Crossing",
  "property_seo_description_referafriend": "Refer a friend to Scissortail Crossing in Broken Arrow, OK! Great friends make great neighbors—share the joy of vibrant living in our welcoming community!",
  "property_seo_title_scheduletour": "Schedule a Tour | Scissortail Crossing",
  "property_seo_description_scheduletour": "Experience the charm of Scissortail Crossing in Broken Arrow, OK. Schedule a tour today and envision your new life where comfort meets community!",
  "property_seo_title_privacy": "Privacy Policy | Scissortail Crossing",
  "property_seo_description_privacy": "At Scissortail Crossing in Broken Arrow, OK, your privacy matters! Discover how we protect your info—view our privacy policy today.",
  "property_seo_title_accessibility": "Website Accessibility | Scissortail Crossing",
  "property_seo_description_accessibility": "At Scissortail Crossing in Broken Arrow, OK, we champion digital inclusion. Join a community where accessibility meets comfort. Everyone is welcome!",
  "property_seo_title_sitemap": "Sitemap | Scissortail Crossing",
  "property_seo_description_sitemap": "Uncover the layout of Scissortail Crossing in Broken Arrow, OK. Navigate our sitemap to find your perfect apartment and explore all we have to offer!",
  "property_seo_title_thankyou": "Thank You | Scissortail Crossing",
  "property_seo_description_thankyou": "Thanks for contacting Scissortail Crossing! Your inquiry is important, and our team will be in touch soon to assist with your apartment search.",
  "property_seo_title_pets": "Pet Policy | Apartments in Broken Arrow, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865719346",
  "amenities": [
    {
      "id": "ec_5fd9ec48db47038b8adf3ed5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127397078",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f598e57016d83e2c20bfb1d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127397079",
      "title": "Resident Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d26fd198ccadce12f355bce4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127397080",
      "title": "Grill & Chill Area by Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a8d94eb1e6940d042f97a900",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127397081",
      "title": "Limited Access Gates",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_609ccfb31136874e0e2a5777",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127397082",
      "title": "Courtyards with Pet Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d69357e79eb4954b3c9af86c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127397083",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_194e4bc58dfc41d20a120401",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127397084",
      "title": "Internet Café with Gourmet Coffee",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_55b2ef16a368f8efc3c54c9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127397085",
      "title": "Onsite Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9055228e4e92083c083a2f6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127397086",
      "title": "Onsite Management with Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9f1069bca4daccb509b5bca5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127397087",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9ee639779ac6148faed6d434",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127397088",
      "title": "Resort-Style Pool with Cabana",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ce2a2743d27ffa3c0bbbfa29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127397089",
      "title": "Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d7db61f4bd9ee4b517e3ec03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127397090",
      "title": "Onsite Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_52c4346d9dac8d0ca52416cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127397091",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8762f1be505e85c994299009",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "128042552",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c2b066dfb9b240646041b029",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127398537",
      "title": "Reliable Cell Reception",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8163d55c207fd97be3c765d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127398538",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_020a9ca3aade3f52a1505a06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127398539",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_186129cf82d43dcbe3686cce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127398540",
      "title": "Central Heat & Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5ae69410083d1dbfa22d1d42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127398541",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_03fc230bde58723d495d80d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127398542",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ebed7d25814f8b5056a8875e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127398543",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f509ba48b1a4a6ed57c768ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127398544",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7dbc24013db674596a1518f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127398545",
      "title": "Cozy Fireplace*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d8ba610284078177071d4258",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127398546",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0de98ce847670c15c2414f72",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127398547",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8f891947e9a29e9e5293eac0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127398548",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4c0704e3ec22634374938d6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127398549",
      "title": "Private Patio or Balcony*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1603f89c298ba0693df5e050",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127398550",
      "title": "Side-by-Side Refrigerator with Ice Maker & Filtered Water",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0108bf773610e95791695354",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127398551",
      "title": "Washer & Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8a9951aa1687005746db1666",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127398552",
      "title": "Handicapped Accessible*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aca3d2c652f46a72c6f943c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127398553",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_51e72b1e4b42735c1f2a4e34",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127398554",
      "title": "Garages Available*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_710fbdcec4a70bb014eccaf3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127398555",
      "title": "Cox Homelife",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b18cd5ef8b03a297acf3311c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127398556",
      "title": "Designer Colors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e005707cad8134e54734598f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "yardi",
      "external_id": "127398557",
      "title": "Loft-Style Living*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_6d12e35d-d32b-4c1d-9120-71ed1f2e2581",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccd-c269-726b-bce9-e1fc7dbf8829.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with a fenced dog park in the foreground.",
        "public_id": "019fdccd-c269-726b-bce9-e1fc7dbf8829",
        "storage_key": "property/6767906449167051/019fdccd-c269-726b-bce9-e1fc7dbf8829.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy our community's dedicated dog park, perfect for your furry friends to play and socialize.",
      "link": "",
      "alt_text": "Apartment building exterior with a fenced dog park in the foreground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1fbe9f82-f627-4b73-a9e9-1b0d5dadb0c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccd-bcf8-7497-a9ad-149ad5142a40.webp",
      "image_media": {
        "alt_text": "Dog park with a tunnel, benches, and agility equipment.",
        "public_id": "019fdccd-bcf8-7497-a9ad-149ad5142a40",
        "storage_key": "property/6767906449167051/019fdccd-bcf8-7497-a9ad-149ad5142a40.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Let your furry friends run and play in our spacious and secure dog park, complete with fun agility features.",
      "link": "",
      "alt_text": "Dog park with a tunnel, benches, and agility equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_71ef1cd3-c899-4aff-ba49-c3f0c2f8c5df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccd-b218-73bc-b0eb-f6d458b3f1b9.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with brick and grey siding, surrounded by manicured lawns.",
        "public_id": "019fdccd-b218-73bc-b0eb-f6d458b3f1b9",
        "storage_key": "property/6767906449167051/019fdccd-b218-73bc-b0eb-f6d458b3f1b9.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Experience comfortable living in this apartment community, featuring well-maintained exteriors and lush green spaces.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building with brick and grey siding, surrounded by manicured lawns.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_881e7a7e-db23-45c8-9a36-8300523b6f4d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccd-b712-73df-a7c9-23ae48296386.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with garages and parking lot.",
        "public_id": "019fdccd-b712-73df-a7c9-23ae48296386",
        "storage_key": "property/6767906449167051/019fdccd-b712-73df-a7c9-23ae48296386.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings with garages and parking lot. Features a clean and modern facade with brick and siding accents.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with garages and parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d01cff90-cdd8-4ca4-9725-680b381a0445",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccd-b657-7419-b032-dcb1324a841d.webp",
      "image_media": {
        "alt_text": "Exterior of a multifamily apartment building with multiple levels and balconies.",
        "public_id": "019fdccd-b657-7419-b032-dcb1324a841d",
        "storage_key": "property/6767906449167051/019fdccd-b657-7419-b032-dcb1324a841d.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "View of the exterior of the apartment building, showcasing its modern design and balconies. This image highlights the building's facade and grounds.",
      "link": "",
      "alt_text": "Exterior of a multifamily apartment building with multiple levels and balconies.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6d34ad66-d2a8-440d-8ff2-b09b2f40946e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccd-a4fd-71e6-9728-d77b3f50b87f.webp",
      "image_media": {
        "alt_text": "Covered patio with seating and pool view",
        "public_id": "019fdccd-a4fd-71e6-9728-d77b3f50b87f",
        "storage_key": "property/6767906449167051/019fdccd-a4fd-71e6-9728-d77b3f50b87f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind in our comfortable outdoor seating area, adjacent to the sparkling swimming pool.",
      "link": "",
      "alt_text": "Covered patio with seating and pool view",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e9220277-87ab-41f4-89da-16da0e9faa9f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccd-a687-74d2-8807-b73f2f1e4349.webp",
      "image_media": {
        "alt_text": "Large outdoor swimming pool with blue lounge chairs and umbrellas surrounding it. Apartment buildings are in the background.",
        "public_id": "019fdccd-a687-74d2-8807-b73f2f1e4349",
        "storage_key": "property/6767906449167051/019fdccd-a687-74d2-8807-b73f2f1e4349.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and shaded areas perfect for relaxing.",
      "link": "",
      "alt_text": "Large outdoor swimming pool with blue lounge chairs and umbrellas surrounding it. Apartment buildings are in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ca14b3b6-8b8f-4ace-9c18-f900a90779ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccd-a352-746e-97c7-6c94e9ec0faa.webp",
      "image_media": {
        "alt_text": "Covered patio with comfortable seating and a TV, overlooking a courtyard.",
        "public_id": "019fdccd-a352-746e-97c7-6c94e9ec0faa",
        "storage_key": "property/6767906449167051/019fdccd-a352-746e-97c7-6c94e9ec0faa.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy relaxation and entertainment in our beautifully appointed outdoor lounge area, complete with plush seating and a large television.",
      "link": "",
      "alt_text": "Covered patio with comfortable seating and a TV, overlooking a courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c4ebf403-14f8-4cc6-ae04-98c4c1bfac36",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccd-9b2d-7086-b05d-6b07c367664d.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with picnic tables, grills, and a stone fireplace.",
        "public_id": "019fdccd-9b2d-7086-b05d-6b07c367664d",
        "storage_key": "property/6767906449167051/019fdccd-9b2d-7086-b05d-6b07c367664d.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and gatherings at our community's grilling station, complete with picnic tables and a cozy fireplace.",
      "link": "",
      "alt_text": "Outdoor grilling station with picnic tables, grills, and a stone fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4ca94f99-be51-4fbb-a996-f384925957fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccd-9cfe-75ab-90bc-45346d7d9c6b.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019fdccd-9cfe-75ab-90bc-45346d7d9c6b",
        "storage_key": "property/6767906449167051/019fdccd-9cfe-75ab-90bc-45346d7d9c6b.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush landscaping, with beautiful apartment buildings providing a scenic backdrop.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d2d8e228-a999-4f8c-8851-8c6c33527c3a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccd-9d06-7413-a4f8-cba034299397.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabana at a multifamily apartment complex.",
        "public_id": "019fdccd-9d06-7413-a4f8-cba034299397",
        "storage_key": "property/6767906449167051/019fdccd-9d06-7413-a4f8-cba034299397.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling resort-style swimming pool, complete with comfortable lounge chairs and a shaded cabana. Perfect for soaking up the sun and enjoying the outdoors.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and cabana at a multifamily apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_74253cf0-435a-46d4-a693-eb919257f455",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccd-96ba-747e-9611-917fbf704a84.webp",
      "image_media": {
        "alt_text": "Outdoor grilling and seating area with picnic tables, grills, and a fireplace.",
        "public_id": "019fdccd-96ba-747e-9611-917fbf704a84",
        "storage_key": "property/6767906449167051/019fdccd-96ba-747e-9611-917fbf704a84.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy al fresco dining and socializing in our community's outdoor grilling and seating area, complete with picnic tables, built-in grills, and a cozy fireplace.",
      "link": "",
      "alt_text": "Outdoor grilling and seating area with picnic tables, grills, and a fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fea873ec-5587-440f-9c5d-efaabf361a9d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccd-8c2e-775a-84f0-71f3bf507746.webp",
      "image_media": {
        "alt_text": "Exterior building entrance with stone accents, covered walkway, and manicured landscaping.",
        "public_id": "019fdccd-8c2e-775a-84f0-71f3bf507746",
        "storage_key": "property/6767906449167051/019fdccd-8c2e-775a-84f0-71f3bf507746.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to the beautifully landscaped entrance of our community, featuring elegant architecture and convenient parking.",
      "link": "",
      "alt_text": "Exterior building entrance with stone accents, covered walkway, and manicured landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_19b84dc4-fb37-4828-bee1-376dacf80ef1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccd-8c9b-74a9-aae9-ca4d2ad977c6.webp",
      "image_media": {
        "alt_text": "Exterior of a multifamily property with brick and siding, covered entrance, and landscaping.",
        "public_id": "019fdccd-8c9b-74a9-aae9-ca4d2ad977c6",
        "storage_key": "property/6767906449167051/019fdccd-8c9b-74a9-aae9-ca4d2ad977c6.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to our community's inviting exterior, featuring beautiful architecture and lush landscaping. Discover your new home today!",
      "link": "",
      "alt_text": "Exterior of a multifamily property with brick and siding, covered entrance, and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d70cc3c9-09d7-4daa-8365-a7519fd92f30",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccd-8d83-77bc-be7f-31a2e1d8990a.webp",
      "image_media": {
        "alt_text": "Courtyard with seating, grills, and a modern sculpture.",
        "public_id": "019fdccd-8d83-77bc-be7f-31a2e1d8990a",
        "storage_key": "property/6767906449167051/019fdccd-8d83-77bc-be7f-31a2e1d8990a.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy the outdoor courtyard with comfortable seating, convenient grilling stations, and a unique modern sculpture. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Courtyard with seating, grills, and a modern sculpture.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7fa142ee-cde1-488d-8292-89209206b35a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccd-85db-722e-9622-93237a60dd15.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a king-size bed, wooden furniture, and a ceiling fan.",
        "public_id": "019fdccd-85db-722e-9622-93237a60dd15",
        "storage_key": "property/6767906449167051/019fdccd-85db-722e-9622-93237a60dd15.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Experience comfort in our spacious bedrooms, featuring elegant wooden furniture and a relaxing ambiance.",
      "link": "",
      "alt_text": "Cozy bedroom with a king-size bed, wooden furniture, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c702b7b2-f60d-4bc9-a5b0-d4197ee019ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccd-85c7-7255-ad17-67acd1162e87.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, marble countertop, and walk-in shower with white tiles.",
        "public_id": "019fdccd-85c7-7255-ad17-67acd1162e87",
        "storage_key": "property/6767906449167051/019fdccd-85c7-7255-ad17-67acd1162e87.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A clean and bright bathroom featuring a white vanity with a marble countertop, ample storage, and a refreshing walk-in shower.",
      "link": "",
      "alt_text": "Modern bathroom with white vanity, marble countertop, and walk-in shower with white tiles.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1a9d7ed3-4e2e-4bf0-a791-db14db350ce9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccd-70df-719f-9621-afa8e09a1c54.webp",
      "image_media": {
        "alt_text": "Dining room with a table and four chairs, large windows with blinds and curtains, and decorative plants.",
        "public_id": "019fdccd-70df-719f-9621-afa8e09a1c54",
        "storage_key": "property/6767906449167051/019fdccd-70df-719f-9621-afa8e09a1c54.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Elegant dining room featuring a modern wooden table and chairs, complemented by large windows offering scenic views and tasteful decor.",
      "link": "",
      "alt_text": "Dining room with a table and four chairs, large windows with blinds and curtains, and decorative plants.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_41422c60-2eb7-4097-8d47-c44a62ba6bef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccd-67b6-773c-9bb7-c6c4bad6c5d6.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with a picnic table and grill area.",
        "public_id": "019fdccd-67b6-773c-9bb7-c6c4bad6c5d6",
        "storage_key": "property/6767906449167051/019fdccd-67b6-773c-9bb7-c6c4bad6c5d6.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy outdoor living with our community picnic area, complete with tables and grills. Perfect for a relaxing afternoon or gathering with friends.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with a picnic table and grill area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0bcb003f-8621-4d92-97e9-32918e5dc086",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccd-6708-708b-b8a7-adb902e6c41c.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white tub, toilet, vanity, and wood-look tile flooring.",
        "public_id": "019fdccd-6708-708b-b8a7-adb902e6c41c",
        "storage_key": "property/6767906449167051/019fdccd-6708-708b-b8a7-adb902e6c41c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Step into a clean and updated bathroom featuring a spacious vanity, tiled shower, and elegant wood-look flooring.",
      "link": "",
      "alt_text": "Modern bathroom with a white tub, toilet, vanity, and wood-look tile flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_67afd7df-ad6c-46d7-92ed-1a029f516454",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccd-6643-747f-9752-fe2aa6f853b5.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, ceiling fan, and decorative wall shelves.",
        "public_id": "019fdccd-6643-747f-9752-fe2aa6f853b5",
        "storage_key": "property/6767906449167051/019fdccd-6643-747f-9752-fe2aa6f853b5.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in the spacious bedroom, complete with a comfortable bed, ceiling fan, and elegant decor.",
      "link": "",
      "alt_text": "Bedroom with a large bed, ceiling fan, and decorative wall shelves.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_22754563-f151-4ba1-b40f-6f9308a07484",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccb-3ff1-775c-bb66-18b3bd84337b.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, sofa, coffee table, and a desk area.",
        "public_id": "019fdccb-3ff1-775c-bb66-18b3bd84337b",
        "storage_key": "property/6767906449167051/019fdccb-3ff1-775c-bb66-18b3bd84337b.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this spacious living area, featuring a cozy fireplace, plush sofa, and a dedicated workspace.",
      "link": "",
      "alt_text": "Living room with a fireplace, sofa, coffee table, and a desk area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_aeae5837-bf0b-46fc-8d3d-b8750f1b09e5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccb-459e-750b-82c1-b6e69c329acd.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinets.",
        "public_id": "019fdccb-459e-750b-82c1-b6e69c329acd",
        "storage_key": "property/6767906449167051/019fdccb-459e-750b-82c1-b6e69c329acd.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Experience comfort and convenience in this modern kitchen featuring stainless steel appliances and ample cabinet space.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and white cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_97bb4978-0fc3-439e-9106-26ec874e280d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccb-43af-7242-a7a2-98ecfdce5190.webp",
      "image_media": {
        "alt_text": "Modern white kitchen with granite countertops, stainless steel appliances, and a breakfast bar.",
        "public_id": "019fdccb-43af-7242-a7a2-98ecfdce5190",
        "storage_key": "property/6767906449167051/019fdccb-43af-7242-a7a2-98ecfdce5190.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Bright and spacious kitchen featuring white cabinetry, a large refrigerator, a microwave, a dishwasher, and a breakfast bar with seating.",
      "link": "",
      "alt_text": "Modern white kitchen with granite countertops, stainless steel appliances, and a breakfast bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0112706c-55a3-40dc-bfd4-3bd20ce24952",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccb-3e85-75d8-84df-3e1d2a7b3f95.webp",
      "image_media": {
        "alt_text": "Front door with a wreath, welcome mat, and porch.",
        "public_id": "019fdccb-3e85-75d8-84df-3e1d2a7b3f95",
        "storage_key": "property/6767906449167051/019fdccb-3e85-75d8-84df-3e1d2a7b3f95.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Community",
      "description": "A bright blue front door with a wreath and a welcome mat sits on a wooden porch.",
      "link": "",
      "alt_text": "Front door with a wreath, welcome mat, and porch.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b7814592-36e7-452f-874e-8486be086fb2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccb-4133-7735-a077-2a20ce683db1.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, TV, and view of a bedroom.",
        "public_id": "019fdccb-4133-7735-a077-2a20ce683db1",
        "storage_key": "property/6767906449167051/019fdccb-4133-7735-a077-2a20ce683db1.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, entertainment center, and an adjacent bedroom.",
      "link": "",
      "alt_text": "Living room with a fireplace, TV, and view of a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8eda0d42-2c01-46f2-b8af-9394271877c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccb-43b0-72e9-aa0f-d97484692650.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a marble-look countertop.",
        "public_id": "019fdccb-43b0-72e9-aa0f-d97484692650",
        "storage_key": "property/6767906449167051/019fdccb-43b0-72e9-aa0f-d97484692650.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious and well-equipped kitchen featuring ample cabinet space, a full suite of modern appliances, and sleek countertops. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a marble-look countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_84e8549c-8be4-4d8a-bfc7-3c99562734e0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccb-3fc2-74fb-b79f-114aa9eba208.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with a sofa, coffee table, dining table, and bar stools.",
        "public_id": "019fdccb-3fc2-74fb-b79f-114aa9eba208",
        "storage_key": "property/6767906449167051/019fdccb-3fc2-74fb-b79f-114aa9eba208.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living room and kitchen area featuring a comfortable sofa, modern coffee table, dining area, and a breakfast bar with stools.",
      "link": "",
      "alt_text": "Living room and kitchen area with a sofa, coffee table, dining table, and bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8e0e1bf4-6f4d-4d26-a2dd-d0c087fe0d74",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccb-305c-7669-a57e-dc0dce1d226c.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, dresser, and ceiling fan.",
        "public_id": "019fdccb-305c-7669-a57e-dc0dce1d226c",
        "storage_key": "property/6767906449167051/019fdccb-305c-7669-a57e-dc0dce1d226c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed bedroom, featuring a plush queen-size bed, elegant nightstand, and spacious dresser. A ceiling fan provides comfort and air circulation.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstand, dresser, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_07605309-ca16-471b-9b9a-f5896fc0a808",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccb-2314-7538-82bd-bb2e10383d25.webp",
      "image_media": {
        "alt_text": "Balcony with two chairs and a table, overlooking apartment buildings and green space.",
        "public_id": "019fdccb-2314-7538-82bd-bb2e10383d25",
        "storage_key": "property/6767906449167051/019fdccb-2314-7538-82bd-bb2e10383d25.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on this private balcony, offering picturesque views of the community and surrounding greenery.",
      "link": "",
      "alt_text": "Balcony with two chairs and a table, overlooking apartment buildings and green space.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6580f4dc-56cf-449a-a555-cf4bc0290785",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccb-2559-7667-b2bf-3ac36e2a5505.webp",
      "image_media": {
        "alt_text": "Bedroom with tufted headboard, dresser, and ceiling fan.",
        "public_id": "019fdccb-2559-7667-b2bf-3ac36e2a5505",
        "storage_key": "property/6767906449167051/019fdccb-2559-7667-b2bf-3ac36e2a5505.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed with a decorative headboard, a dresser with a mirror, and a ceiling fan for added comfort.",
      "link": "",
      "alt_text": "Bedroom with tufted headboard, dresser, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e0f6d5af-ebdc-4931-b30d-9df85e9590b8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccb-2c85-7211-b30c-bb81ddc95692.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, tub/shower, and decorative shelving.",
        "public_id": "019fdccb-2c85-7211-b30c-bb81ddc95692",
        "storage_key": "property/6767906449167051/019fdccb-2c85-7211-b30c-bb81ddc95692.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Step into this stylish bathroom featuring a clean white vanity, a relaxing tub/shower combo, and decorative shelving to add a personal touch.",
      "link": "",
      "alt_text": "Modern bathroom with white vanity, tub/shower, and decorative shelving.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fb250249-0064-4bcd-bc38-cb2e1ecfd04f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccb-22a0-7782-ad17-2cbf793f998b.webp",
      "image_media": {
        "alt_text": "Kitchen area with white cabinets, stainless steel appliances, and a countertop.",
        "public_id": "019fdccb-22a0-7782-ad17-2cbf793f998b",
        "storage_key": "property/6767906449167051/019fdccb-22a0-7782-ad17-2cbf793f998b.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring white cabinetry, a stainless steel microwave, stove, and dishwasher. The space opens to the living area.",
      "link": "",
      "alt_text": "Kitchen area with white cabinets, stainless steel appliances, and a countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a0ff64dc-230c-47ce-88a6-a80dc0bd1db4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccb-105c-72ff-bd76-6a49d5d3c3a3.webp",
      "image_media": {
        "alt_text": "Dining area with a wooden table and four chairs, decorative mirrors on the wall.",
        "public_id": "019fdccb-105c-72ff-bd76-6a49d5d3c3a3",
        "storage_key": "property/6767906449167051/019fdccb-105c-72ff-bd76-6a49d5d3c3a3.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Elegant dining area featuring a wooden table with seating for four, complemented by decorative gold-framed mirrors on a gray accent wall.",
      "link": "",
      "alt_text": "Dining area with a wooden table and four chairs, decorative mirrors on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_177420aa-8d6b-41d0-8ca8-1a2d850e4efb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccb-14b4-712f-a1b9-aa2e147e6fc4.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, gray countertops, stainless steel appliances, and a microwave.",
        "public_id": "019fdccb-14b4-712f-a1b9-aa2e147e6fc4",
        "storage_key": "property/6767906449167051/019fdccb-14b4-712f-a1b9-aa2e147e6fc4.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Discover your perfect culinary space in this bright and functional kitchen, featuring ample cabinet storage, sleek countertops, and modern appliances.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, gray countertops, stainless steel appliances, and a microwave.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_abf0644c-c7bc-47e6-84f8-2d0333af2b02",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccb-0e7d-721d-aab0-90b2555ef898.webp",
      "image_media": {
        "alt_text": "Living room with a white sofa, white ottoman, and dining area.",
        "public_id": "019fdccb-0e7d-721d-aab0-90b2555ef898",
        "storage_key": "property/6767906449167051/019fdccb-0e7d-721d-aab0-90b2555ef898.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a plush white sofa, a decorative ottoman, and a separate dining area, perfect for entertaining.",
      "link": "",
      "alt_text": "Living room with a white sofa, white ottoman, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_98c82eb8-4b46-4016-9295-2ac642dc870b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccb-0ce8-759e-b100-d0f877ac3d64.webp",
      "image_media": {
        "alt_text": "Living room and bedroom in an apartment",
        "public_id": "019fdccb-0ce8-759e-b100-d0f877ac3d64",
        "storage_key": "property/6767906449167051/019fdccb-0ce8-759e-b100-d0f877ac3d64.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Stylish and comfortable living room with a plush sofa, ottoman, and entertainment center, connected to a bedroom.",
      "link": "",
      "alt_text": "Living room and bedroom in an apartment",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bef43514-c0e6-43d5-a49d-42c15137213c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdcca-ec09-7113-9a2d-5e313e7060a8.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, armchair, coffee table, and dining area.",
        "public_id": "019fdcca-ec09-7113-9a2d-5e313e7060a8",
        "storage_key": "property/6767906449167051/019fdcca-ec09-7113-9a2d-5e313e7060a8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living and dining area with comfortable seating, modern decor, and ample natural light.",
      "link": "",
      "alt_text": "Living room with a sofa, armchair, coffee table, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_63d50891-b9c7-410b-9f9f-46c69ed4da12",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdcca-ed87-7396-a1ff-0f69ca32c66d.webp",
      "image_media": {
        "alt_text": "Open-concept living room and kitchen with a large sectional sofa, coffee table, and kitchen island with bar stools.",
        "public_id": "019fdcca-ed87-7396-a1ff-0f69ca32c66d",
        "storage_key": "property/6767906449167051/019fdcca-ed87-7396-a1ff-0f69ca32c66d.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area featuring a comfortable sectional sofa, modern coffee table, and a fully equipped kitchen with a breakfast bar and bar stools. Perfect for entertaining and everyday living.",
      "link": "",
      "alt_text": "Open-concept living room and kitchen with a large sectional sofa, coffee table, and kitchen island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f938fbc8-4c59-4fe7-90e1-28652c76dda7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdcca-e5b0-77ea-afc0-2e771d2b9522.webp",
      "image_media": {
        "alt_text": "Laundry room with two white washers and dryers, a breaker box, and a \"FETCH\" sign.",
        "public_id": "019fdcca-e5b0-77ea-afc0-2e771d2b9522",
        "storage_key": "property/6767906449167051/019fdcca-e5b0-77ea-afc0-2e771d2b9522.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry facilities feature full-sized washers and dryers, making chore day a breeze. The space also includes a breaker box for easy access.",
      "link": "",
      "alt_text": "Laundry room with two white washers and dryers, a breaker box, and a \"FETCH\" sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9deda4be-0d66-4004-8640-61ca4ca5b4f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdcca-f19f-753a-a18a-b57803f211e7.webp",
      "image_media": {
        "alt_text": "A cozy bedroom with a queen-size bed, dresser, and ceiling fan.",
        "public_id": "019fdcca-f19f-753a-a18a-b57803f211e7",
        "storage_key": "property/6767906449167051/019fdcca-f19f-753a-a18a-b57803f211e7.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in comfort in this spacious bedroom, featuring a plush queen-size bed, elegant dresser, and a convenient ceiling fan for year-round comfort.",
      "link": "",
      "alt_text": "A cozy bedroom with a queen-size bed, dresser, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4cde7a4c-3008-43eb-85c3-1e46c5177827",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdcca-c1f4-71b2-adc6-ae3a7489bbbc.webp",
      "image_media": {
        "alt_text": "Dining area with a glass table and four chairs, adjacent to a desk and windows.",
        "public_id": "019fdcca-c1f4-71b2-adc6-ae3a7489bbbc",
        "storage_key": "property/6767906449167051/019fdcca-c1f4-71b2-adc6-ae3a7489bbbc.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A well-lit dining area featuring a modern glass-top table with four upholstered chairs, perfect for meals and entertaining. The space also includes a comfortable desk area by the window.",
      "link": "",
      "alt_text": "Dining area with a glass table and four chairs, adjacent to a desk and windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a88fbf51-5212-4d23-a214-5b1904e000c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdcca-c1f3-77da-89c7-a938d837edce.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, sofa, and armchair.",
        "public_id": "019fdcca-c1f3-77da-89c7-a938d837edce",
        "storage_key": "property/6767906449167051/019fdcca-c1f3-77da-89c7-a938d837edce.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, comfortable seating, and elegant decor.",
      "link": "",
      "alt_text": "Living room with fireplace, sofa, and armchair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1fe95b49-c8a6-4bfd-b9b0-e0d27ce0823a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdcca-c17b-74e2-a23e-be6fad5f716f.webp",
      "image_media": {
        "alt_text": "Dining area and desk space in an apartment living room.",
        "public_id": "019fdcca-c17b-74e2-a23e-be6fad5f716f",
        "storage_key": "property/6767906449167051/019fdcca-c17b-74e2-a23e-be6fad5f716f.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy a dedicated workspace and a formal dining area in this spacious apartment layout.",
      "link": "",
      "alt_text": "Dining area and desk space in an apartment living room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_93d6d6fe-7830-4b1b-8102-eabdba45a904",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdcca-c02e-70fe-8af6-03f660976469.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, an elliptical, and weight machines.",
        "public_id": "019fdcca-c02e-70fe-8af6-03f660976469",
        "storage_key": "property/6767906449167051/019fdcca-c02e-70fe-8af6-03f660976469.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a variety of cardio and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills, an elliptical, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4ce66358-c181-419a-97e9-576ae2b18c85",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdcca-30aa-7671-82fa-1fe1bcd2e433.webp",
      "image_media": {
        "alt_text": "Communal living area with fireplace, kitchen, and dining table.",
        "public_id": "019fdcca-30aa-7671-82fa-1fe1bcd2e433",
        "storage_key": "property/6767906449167051/019fdcca-30aa-7671-82fa-1fe1bcd2e433.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the communal living area featuring a cozy fireplace, a fully equipped kitchen, and a spacious dining table perfect for gatherings.",
      "link": "",
      "alt_text": "Communal living area with fireplace, kitchen, and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4c9fc297-7e0f-4c77-9f09-b90eceb8d3a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdcca-11e1-7760-9960-c3c18d041338.webp",
      "image_media": {
        "alt_text": "Spacious communal lounge area with large windows, fireplace, comfortable seating, and modern decor.",
        "public_id": "019fdcca-11e1-7760-9960-c3c18d041338",
        "storage_key": "property/6767906449167051/019fdcca-11e1-7760-9960-c3c18d041338.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Enjoy the expansive and beautifully designed communal lounge, perfect for relaxing or socializing. This inviting space features a cozy fireplace and ample seating.",
      "link": "",
      "alt_text": "Spacious communal lounge area with large windows, fireplace, comfortable seating, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2732ab83-708e-462b-9a87-95a07875a215",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdcca-0ea7-775d-9938-641d5310cc10.webp",
      "image_media": {
        "alt_text": "Lobby area with comfortable seating, coffee table, and large windows overlooking the exterior.",
        "public_id": "019fdcca-0ea7-775d-9938-641d5310cc10",
        "storage_key": "property/6767906449167051/019fdcca-0ea7-775d-9938-641d5310cc10.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Step into our beautifully designed lobby, featuring plush seating and a welcoming ambiance. Perfect for relaxing or meeting guests.",
      "link": "",
      "alt_text": "Lobby area with comfortable seating, coffee table, and large windows overlooking the exterior.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_97cf444d-16df-41da-b67e-e54ca806f213",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "custom",
      "poi_name": "Northeastern State University Broken Arrow",
      "poi_type": "Education",
      "poi_address": "3100 New Orleans St, Broken Arrow, OK 74014, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019d7917-3e5c-76ea-a469-6f0c7f1ed5d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-3e5c-76ea-a469-6f0c7f1ed5d5",
        "storage_key": "property/6767906449167051/019d7917-3e5c-76ea-a469-6f0c7f1ed5d5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nsuok.edu/BrokenArrow.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3996275873980647977&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "northeastern-state-university-broken-arrow",
      "poi_latitude": "36.019379",
      "poi_longitude": "-95.748523",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-449-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019cfb54-5cda-7252-ac5c-bd86f83b5340.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-5cda-7252-ac5c-bd86f83b5340",
        "storage_key": "property/6767906449167051/019cfb54-5cda-7252-ac5c-bd86f83b5340.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6bWtJw_7yYcRKYoU9bufdTc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_e8da2d81-398f-47a1-8929-859fc7f74047",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "custom",
      "poi_name": "The University of Tulsa",
      "poi_type": "Education",
      "poi_address": "800 S Tucker Dr, Tulsa, OK 74104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019d7917-3eb0-766d-bf42-ce18721ffa72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-3eb0-766d-bf42-ce18721ffa72",
        "storage_key": "property/6767906449167051/019d7917-3eb0-766d-bf42-ce18721ffa72.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.utulsa.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12534755682749092613&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-university-of-tulsa",
      "poi_latitude": "36.1520526",
      "poi_longitude": "-95.9460753",
      "poi_miles_from_property": "14.9 mi",
      "poi_walking_minutes": "5 hours 29 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 918-631-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019cfb54-5cda-7252-ac5c-bd86f83b5340.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-5cda-7252-ac5c-bd86f83b5340",
        "storage_key": "property/6767906449167051/019cfb54-5cda-7252-ac5c-bd86f83b5340.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM0KAdPzstocRBZORqOFl9K0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_26c6e940-9ea3-4f73-9190-9d1efb62392e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "custom",
      "poi_name": "Broken Arrow High School",
      "poi_type": "Education",
      "poi_address": "1901 E Albany St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019d7917-3eb9-75eb-80c2-e350070af641.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-3eb9-75eb-80c2-e350070af641",
        "storage_key": "property/6767906449167051/019d7917-3eb9-75eb-80c2-e350070af641.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.baschools.org/o/bahs",
      "poi_directions_map_url": "https://maps.google.com/?cid=9874418802231035849&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "broken-arrow-high-school",
      "poi_latitude": "36.0739737",
      "poi_longitude": "-95.766474",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-259-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019cfb54-5cda-7252-ac5c-bd86f83b5340.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-5cda-7252-ac5c-bd86f83b5340",
        "storage_key": "property/6767906449167051/019cfb54-5cda-7252-ac5c-bd86f83b5340.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOVb0n1GKtocRyUdrbpX7CIk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_9403dfd8-4f06-4f95-808f-2ad584960843",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "custom",
      "poi_name": "Oral Roberts University",
      "poi_type": "Education",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74171, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019d7917-41cb-741c-93b0-a9e63ba34f89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-41cb-741c-93b0-a9e63ba34f89",
        "storage_key": "property/6767906449167051/019d7917-41cb-741c-93b0-a9e63ba34f89.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://oru.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13173931362498967750&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oral-roberts-university",
      "poi_latitude": "36.050518",
      "poi_longitude": "-95.9530171",
      "poi_miles_from_property": "13.1 mi",
      "poi_walking_minutes": "4 hours 52 mins",
      "poi_biking_minutes": "1 hour 37 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 918-495-6161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019cfb54-5cda-7252-ac5c-bd86f83b5340.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-5cda-7252-ac5c-bd86f83b5340",
        "storage_key": "property/6767906449167051/019cfb54-5cda-7252-ac5c-bd86f83b5340.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdwdeD7iTtocRxvgglcY007Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f6842355-4ceb-496b-b294-e7b72d13d60f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "custom",
      "poi_name": "Charleston's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "251 E Hillside Dr, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Relaxed hangout serving classic pub fare, such as burgers, ribs & tenders, plus wine & cocktails.",
      "poi_long_description": "People say this American restaurant serves delicious fried catfish, prime rib, and chicken piccata. They highlight the excellent service, friendly staff, and the cozy, welcoming atmosphere, perfect for gatherings with family and friends. They also like the generous portions and reasonable prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019d7917-4c4d-743f-93aa-d13140df56f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-4c4d-743f-93aa-d13140df56f1",
        "storage_key": "property/6767906449167051/019d7917-4c4d-743f-93aa-d13140df56f1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://charlestons.com/locations/charlestons-broken-arrow/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7215259568967514265&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "charleston-s-restaurant",
      "poi_latitude": "36.0694444",
      "poi_longitude": "-95.7894444",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-355-9177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019cfb54-5ce5-7774-8be5-7ccee9e3734f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-5ce5-7774-8be5-7ccee9e3734f",
        "storage_key": "property/6767906449167051/019cfb54-5ce5-7774-8be5-7ccee9e3734f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJecfxi7OLtocRmfiLklnAIWQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_4eaf9332-3129-46fb-ba44-38e663ca72d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "custom",
      "poi_name": "Louie's Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "1640 N 9th St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Casual hangout with sports on TV & a menu of classic American pub fare.",
      "poi_long_description": "Casual hangout with sports on TV & a menu of classic American pub fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019d7917-4a20-7255-8053-d10d7f3bea98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-4a20-7255-8053-d10d7f3bea98",
        "storage_key": "property/6767906449167051/019d7917-4a20-7255-8053-d10d7f3bea98.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "http://louiesgrillandbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=739989407665203851&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "louie-s-grill-bar",
      "poi_latitude": "36.0684089",
      "poi_longitude": "-95.7804412",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-355-0421",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019d7917-7fd8-7280-9d20-c75113e943ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7917-7fd8-7280-9d20-c75113e943ed",
        "storage_key": "property/6767906449167051/019d7917-7fd8-7280-9d20-c75113e943ed.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNYMvTraLtocRi6pvFXL4RAo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_875fbbed-125a-4280-95b1-f675191496bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "custom",
      "poi_name": "Slim Chickens",
      "poi_type": "Restaurants",
      "poi_address": "1100 E Hillside Dr, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Counter-serve chain specializing in chicken dishes, plus Southern sides & desserts served in jars.",
      "poi_long_description": "People say this chicken restaurant serves fresh, crunchy chicken, and good fries. They also highlight the friendly staff, fast service, and clean atmosphere.\n\nOther reviews mention the food can be dry.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019d7917-4e89-7733-9457-b70e184ba3a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-4e89-7733-9457-b70e184ba3a5",
        "storage_key": "property/6767906449167051/019d7917-4e89-7733-9457-b70e184ba3a5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://slimchickens.com/?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=12010630507351978246&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "slim-chickens",
      "poi_latitude": "36.0677042",
      "poi_longitude": "-95.7779044",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-940-3255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019cfb54-5ce5-7774-8be5-7ccee9e3734f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-5ce5-7774-8be5-7ccee9e3734f",
        "storage_key": "property/6767906449167051/019cfb54-5ce5-7774-8be5-7ccee9e3734f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJeZ9aj7GLtocRBjEvt89UrqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_restaurant"
    },
    {
      "id": "custom_f086e9d8-52dd-413d-8da1-415d761cb3e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "custom",
      "poi_name": "Egg It On Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1131 S Aspen Ave, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Unassuming, simple diner serving comfort foods like omelets & burgers for breakfast & lunch.",
      "poi_long_description": "People say this cafe serves delicious crepes, breakfast tostadas, and Baja potatoes. They highlight the reasonable prices, clean atmosphere, and friendly staff. They also like the quiet and pleasant vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019d7917-50d3-727c-b35d-9a3f48272d7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-50d3-727c-b35d-9a3f48272d7b",
        "storage_key": "property/6767906449167051/019d7917-50d3-727c-b35d-9a3f48272d7b.webp",
        "width": 1280,
        "height": 607
      },
      "poi_business_url": "http://www.eggitoncafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3121501714821878374&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "egg-it-on-cafe",
      "poi_latitude": "36.0442099",
      "poi_longitude": "-95.8137392",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-254-0455",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019d7917-800c-76f5-aa42-1edd440a448a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7917-800c-76f5-aa42-1edd440a448a",
        "storage_key": "property/6767906449167051/019d7917-800c-76f5-aa42-1edd440a448a.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJWYsmGmyMtocRZhK7bUXNUSs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_e52b5d64-6b08-42a6-b6ee-a9f51ab119c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "custom",
      "poi_name": "All About Cha Cafe & Restaurant - Broken Arrow",
      "poi_type": "Restaurants",
      "poi_address": "820 N Aspen Ave, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Cozy spot for breakfast, bubble tea, and coffee, plus Korean fare such as bento boxes and bulgogi wraps.",
      "poi_long_description": "People say this bubble tea store offers a wide variety of teas, as well as food options like sushi and cheesecake. They highlight the reasonable prices and the relaxed, peaceful atmosphere, perfect for chatting or meetings. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019d7917-530a-709d-8554-1bb6183449cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-530a-709d-8554-1bb6183449cc",
        "storage_key": "property/6767906449167051/019d7917-530a-709d-8554-1bb6183449cc.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://allaboutchaba.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=17532261031567663262&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "all-about-cha-cafe-restaurant-broken-arrow",
      "poi_latitude": "36.0593669",
      "poi_longitude": "-95.8159067",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-940-7171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019cfb54-5ce5-7774-8be5-7ccee9e3734f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-5ce5-7774-8be5-7ccee9e3734f",
        "storage_key": "property/6767906449167051/019cfb54-5ce5-7774-8be5-7ccee9e3734f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl2p8zOaNtocRnqADsIQaT_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_bd4eefc8-dbd1-4965-a8f1-1be64fd0682e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "custom",
      "poi_name": "Andy's Frozen Custard",
      "poi_type": "Restaurants",
      "poi_address": "800 E Kenosha St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Frozen custard sundaes, concretes & more, plus a choice of toppings (with a drive-thru window).",
      "poi_long_description": "People say this dessert shop serves delicious frozen custard, including Key Lime and banana strawberry concretes. They highlight the friendly staff and the generous portions. They also like the convenient drive-thru service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019d7917-595f-734b-b70d-611ecdc634b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-595f-734b-b70d-611ecdc634b3",
        "storage_key": "property/6767906449167051/019d7917-595f-734b-b70d-611ecdc634b3.webp",
        "width": 1123,
        "height": 1280
      },
      "poi_business_url": "https://locations.eatandys.com/ll/US/OK/Broken-Arrow/800-East-Kenosha-Street",
      "poi_directions_map_url": "https://maps.google.com/?cid=16664202146947279550&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "andy-s-frozen-custard",
      "poi_latitude": "36.0614652",
      "poi_longitude": "-95.7816627",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-856-5275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019cfb54-5cda-7252-ac5c-c2300aadd81c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-5cda-7252-ac5c-c2300aadd81c",
        "storage_key": "property/6767906449167051/019cfb54-5cda-7252-ac5c-c2300aadd81c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ424inbeLtocRvioY2o8jQ-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dessert_shop"
    },
    {
      "id": "custom_294f25d4-c56a-4cb5-880b-b19d7e3c564e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "custom",
      "poi_name": "Mahogany Prime Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "4840 E 61st St, Tulsa, OK 74136, USA",
      "poi_short_description": "Sophisticated restaurant offering steaks, seafood & creative cocktails in refined surroundings.",
      "poi_long_description": "People say this steakhouse serves perfectly cooked, flavorful steaks, and delicious lobster mac and cheese. They highlight the excellent service, attentive staff, and upscale, elegant atmosphere, making it ideal for special occasions. They also like the generous portions and good value.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019d7917-5965-77ee-a94c-3ecb7761e3ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-5965-77ee-a94c-3ecb7761e3ad",
        "storage_key": "property/6767906449167051/019d7917-5965-77ee-a94c-3ecb7761e3ad.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://mahoganyprimesteakhouse.com/locations/mahogany-tulsa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13122200333241441640&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mahogany-prime-steakhouse",
      "poi_latitude": "36.0744916",
      "poi_longitude": "-95.9237582",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 37 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 918-494-4043",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019cfb54-5ce5-7774-8be5-7ccee9e3734f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-5ce5-7774-8be5-7ccee9e3734f",
        "storage_key": "property/6767906449167051/019cfb54-5ce5-7774-8be5-7ccee9e3734f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1Q_uOV2StocRaF1evq1rG7Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_04ba12c9-a70f-403f-8ba7-9d586c8fe1f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "custom",
      "poi_name": "Fish Daddy's Grill House",
      "poi_type": "Restaurants",
      "poi_address": "10624 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Lively eatery & bar dishing up grilled, blackened or fried fish platters & Cajun specialties.",
      "poi_long_description": "People say this seafood restaurant serves delicious catfish, shrimp, and salmon, and the onion rings are a must-try. They highlight the excellent value, with generous portions and reasonable prices, and the cozy, welcoming atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019d7917-5aee-77ba-9989-54a46827a002.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-5aee-77ba-9989-54a46827a002",
        "storage_key": "property/6767906449167051/019d7917-5aee-77ba-9989-54a46827a002.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.fdtulsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7311857581283797504&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fish-daddy-s-grill-house",
      "poi_latitude": "36.0602301",
      "poi_longitude": "-95.8578103",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-307-1388",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019cfb54-5ce5-7774-8be5-7ccee9e3734f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-5ce5-7774-8be5-7ccee9e3734f",
        "storage_key": "property/6767906449167051/019cfb54-5ce5-7774-8be5-7ccee9e3734f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJo40vf7ONtocRAOqq9LrveGU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_f2aed164-63c5-48ef-b0b7-58b038da6fb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "custom",
      "poi_name": "Villa Ravenna Fine Dining​",
      "poi_type": "Restaurants",
      "poi_address": "Between 51 and Sheridan at the Farm Shopping Center, 6526 E 51st St, Tulsa, OK 74145, USA",
      "poi_short_description": "Family-owned Italian restaurant serving pasta, seafood & meat entrees in white-tablecloth environs.",
      "poi_long_description": "People say this Italian restaurant serves delicious stuffed dates, sea bass, and rack of lamb. They also highlight the cozy and romantic atmosphere, and the attentive and knowledgeable service.\n\nSome reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019d7917-6233-7349-a038-f08aefb8162e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-6233-7349-a038-f08aefb8162e",
        "storage_key": "property/6767906449167051/019d7917-6233-7349-a038-f08aefb8162e.webp",
        "width": 929,
        "height": 1280
      },
      "poi_business_url": "http://www.villaravenna.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2580529075065442448&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "villa-ravenna-fine-dining",
      "poi_latitude": "36.088939",
      "poi_longitude": "-95.902801",
      "poi_miles_from_property": "8.8 mi",
      "poi_walking_minutes": "3 hours 15 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 918-270-2666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019cfb54-5ce5-7774-8be5-7ccee9e3734f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-5ce5-7774-8be5-7ccee9e3734f",
        "storage_key": "property/6767906449167051/019cfb54-5ce5-7774-8be5-7ccee9e3734f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvy69CZyStocRkNDXg4XhzyM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_4df67060-18fe-42ef-acd0-16fcec14a9c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "custom",
      "poi_name": "Cinemark Broken Arrow",
      "poi_type": "Shopping & Retail",
      "poi_address": "1801 E Hillside Dr, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "People say this movie theater offers a wide selection of movies, including 3D options. They also highlight the reasonable ticket prices, clean facilities, and friendly, helpful staff.\n\nOther reviews mention the seats can be uncomfortable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019d7917-644a-71e5-a7ab-141b330da37e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-644a-71e5-a7ab-141b330da37e",
        "storage_key": "property/6767906449167051/019d7917-644a-71e5-a7ab-141b330da37e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/ok-broken-arrow/cinemark-broken-arrow?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTMxMTYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=7062085401556035336&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cinemark-broken-arrow",
      "poi_latitude": "36.0633908",
      "poi_longitude": "-95.7706171",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-355-0427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019cfb54-5cbf-73b9-941e-b70e808681df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-5cbf-73b9-941e-b70e808681df",
        "storage_key": "property/6767906449167051/019cfb54-5cbf-73b9-941e-b70e808681df.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJS_qPa0uKtocRCCc4lUGRAWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_6b329076-1015-4454-99b2-fbc1ffa1debd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "custom",
      "poi_name": "Rose District",
      "poi_type": "Shopping & Retail",
      "poi_address": "Rose District, Broken Arrow, OK 74012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019d7917-6424-776f-8b8f-0cf84b3b172d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-6424-776f-8b8f-0cf84b3b172d",
        "storage_key": "property/6767906449167051/019d7917-6424-776f-8b8f-0cf84b3b172d.webp",
        "width": 622,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14362273052981578792&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rose-district",
      "poi_latitude": "36.0522645",
      "poi_longitude": "-95.79122420000002",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019cfb54-5cc8-7608-b5d3-b0d192566c7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-5cc8-7608-b5d3-b0d192566c7e",
        "storage_key": "property/6767906449167051/019cfb54-5cc8-7608-b5d3-b0d192566c7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMRs3LMKLtocRKMwhQj8LUcc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_51d48d17-d39f-4d59-97b5-745d4087a3a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "1150 E Hillside Dr, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store offers a wide selection of products. They also highlight the friendly and helpful service, and the clean and organized store.\n\nOther reviews mention the pickup service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019d7917-63f9-7772-8531-08348f165cd8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-63f9-7772-8531-08348f165cd8",
        "storage_key": "property/6767906449167051/019d7917-63f9-7772-8531-08348f165cd8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/broken-arrow/2422",
      "poi_directions_map_url": "https://maps.google.com/?cid=14603451760596788981&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "36.0670278",
      "poi_longitude": "-95.7765664",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-615-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019cfb54-5cda-7252-ac5c-c2300aadd81c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-5cda-7252-ac5c-c2300aadd81c",
        "storage_key": "property/6767906449167051/019cfb54-5cda-7252-ac5c-c2300aadd81c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjSo4zLOLtocR9abs_ADiqco",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_2bf069da-7729-4af4-90e0-876a96262023",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "custom",
      "poi_name": "Tiger Plaza On Kenosha LLC",
      "poi_type": "Shopping & Retail",
      "poi_address": "2520 E Kenosha St, Broken Arrow, OK 74014, USA",
      "poi_short_description": "Mall with an eatery specializing in Mexican fare, plus a donut shop and other businesses.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019d7917-6c1d-744a-84f5-2993d97069fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-6c1d-744a-84f5-2993d97069fb",
        "storage_key": "property/6767906449167051/019d7917-6c1d-744a-84f5-2993d97069fb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9078204285870850171&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tiger-plaza-on-kenosha-llc",
      "poi_latitude": "36.0622131",
      "poi_longitude": "-95.7583296",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-355-1584",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019cfb54-5cc8-7608-b5d3-b0d192566c7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-5cc8-7608-b5d3-b0d192566c7e",
        "storage_key": "property/6767906449167051/019cfb54-5cc8-7608-b5d3-b0d192566c7e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9YtFBUeKtocRe8DCGbNC_H0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "custom_fdaf9497-7d74-4db6-8fb3-4c41dbb306db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1300 E Albany St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Friendly neighborhood establishment for everything from fresh produce to toys and electronics.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019d7917-6bd1-758f-84f4-7ed2f4d7a2a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-6bd1-758f-84f4-7ed2f4d7a2a1",
        "storage_key": "property/6767906449167051/019d7917-6bd1-758f-84f4-7ed2f4d7a2a1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walmart.com/store/4655-broken-arrow-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=1291450374524807913&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "36.07620310000001",
      "poi_longitude": "-95.7759056",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-505-6247",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019cfb54-5cd9-7749-b0bc-48aaf59ef791.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-5cd9-7749-b0bc-48aaf59ef791",
        "storage_key": "property/6767906449167051/019cfb54-5cd9-7749-b0bc-48aaf59ef791.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDQ_cjauLtocR6aqY8kUn7BE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_d46e0d95-ba57-40e0-83e4-ef4c5db99fd8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "custom",
      "poi_name": "Military History Museum",
      "poi_type": "Shopping & Retail",
      "poi_address": "112 N Main St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Tours and exhibits of military history that feature donated artifacts and memorabilia.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019d7917-6ec5-767e-9781-ceaeb4769371.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-6ec5-767e-9781-ceaeb4769371",
        "storage_key": "property/6767906449167051/019d7917-6ec5-767e-9781-ceaeb4769371.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.okmhc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13208418279094056410&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "military-history-museum",
      "poi_latitude": "36.0528999",
      "poi_longitude": "-95.7910559",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-794-2712",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019cfb54-5cda-7252-ac5c-c42d497ffee7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-5cda-7252-ac5c-c42d497ffee7",
        "storage_key": "property/6767906449167051/019cfb54-5cda-7252-ac5c-c42d497ffee7.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJLetKKsKLtocR2nUtknG6Tbc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_1b964612-4ce0-4344-a6b1-fb9f29c979cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "custom",
      "poi_name": "The Museum Broken Arrow",
      "poi_type": "Shopping & Retail",
      "poi_address": "400 S Main St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Museum displaying local & regional history via artifacts, special exhibits & various events.",
      "poi_long_description": "Museum displaying local & regional history via artifacts, special exhibits & various events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019d7917-7898-7388-bc84-d7ae8b8d26f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-7898-7388-bc84-d7ae8b8d26f9",
        "storage_key": "property/6767906449167051/019d7917-7898-7388-bc84-d7ae8b8d26f9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.brokenarrowmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16351764218256934691&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-museum-broken-arrow",
      "poi_latitude": "36.0491954",
      "poi_longitude": "-95.7911106",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-258-2616",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019cfb54-5cda-7252-ac5c-c42d497ffee7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-5cda-7252-ac5c-c42d497ffee7",
        "storage_key": "property/6767906449167051/019cfb54-5cda-7252-ac5c-c42d497ffee7.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJMxSi48KLtocRI8cl0Osi7eI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "custom_9e317c56-a3ff-424d-9af9-2c3671fc5bfb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "custom",
      "poi_name": "Haikey Creek Park",
      "poi_type": "Shopping & Retail",
      "poi_address": "11327 S Garnett Rd, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Vast county park boasting picnic area & playgrounds, plus an 18-hole championship disc golf course.",
      "poi_long_description": "People say this park offers a variety of activities, including playgrounds, disc golf, hiking trails, and picnic areas. They highlight the spaciousness, well-maintained grounds, and clean restrooms. They also like the peaceful and family-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019d7917-757d-77ec-ade5-dc49dfa43659.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-757d-77ec-ade5-dc49dfa43659",
        "storage_key": "property/6767906449167051/019d7917-757d-77ec-ade5-dc49dfa43659.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15453125230281067031&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "haikey-creek-park",
      "poi_latitude": "35.9918271",
      "poi_longitude": "-95.8526659",
      "poi_miles_from_property": "10.7 mi",
      "poi_walking_minutes": "3 hours 54 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 918-369-5998",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019cfb54-5cc7-718b-acb3-31d47225a6de.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-5cc7-718b-acb3-31d47225a6de",
        "storage_key": "property/6767906449167051/019cfb54-5cc7-718b-acb3-31d47225a6de.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkz_xefyOtocRF4qH1IWHdNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a24002da-c839-47a1-a7bc-0360372125da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "custom",
      "poi_name": "Hillside Crossing",
      "poi_type": "Shopping & Retail",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "hillside-crossing",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_f762934f857307003d8dbc4d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_6b41d258fa7de94e786257f4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_bc4c01640d230268bf6963bc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_becf1cd6ebe4c701fa47186d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_d390bacc9eed27c9fdd55fa4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_aa25f03a3e0fa063e853cf3f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_39c15f17-e228-47fe-9c15-e65de184ce65",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "rating": "5.0",
      "name": "Sue Yang",
      "text": "All staffs are amazing and makes the place very welcoming. Allyncia is professional and she has excellent customer service. She was very helpful and didn't treat me any different. The process for leasing was smooth and forward.  I've dealt with one other leasing office and there were a lot of hold up and confusion. But I really like it here. My unit has a beautiful accent wall.  High ceiling. All appliances except for washer and dryer. I was able to rent full sized washer/dryer though and perfect fit for designated area in bathroom. I work remotely from home so I have cox high speed for internet. I had trouble with the fiber once but that's because they were new in the area. But other than that, good area to work from home. Quiet neighbors. Close to convenient shipping stores, gas station, park, schools, and easy access to highway. Two gate entries. Clean environment.  No smoking. Business office, fitness center, dog park and pool are great amenities. There's a lot plenty of grass space for your dog to take care of their business and they have posts everywhere to pick up after them. I also feel safer here than most places. Also, maintenance team is quick to response and resolve issues! I never hesitate to request for assistance. I think it would be nice to have little events held for tenants once in awhile. (Add more pictures later)",
      "date": "2023-01-17",
      "title": ""
    },
    {
      "id": "custom_03321422-c8cb-4638-98d4-a80ee9bfa82e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "rating": "5.0",
      "name": "Victory Weight",
      "text": "We are absolutely loving living here! So far my favorite is the amazing natural lighting. It helps me wake up early and feel alive compared to other apartments I have lived in. It’s a very quiet and peaceful environment, with tons of shopping centers and food options close by. The landscaping is beautiful and well kept, it’s gated, they have a gorgeous pool, 24/7 fitness room with everything you need, and a wonderful service staff! If you’re looking for somewhere great to live, I definitely recommend Scissortail Crossing Apartments!",
      "date": "2026-01-16",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_83c49f99-2759-4bdf-8716-787e9574100a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019cfb54-cab8-715d-988b-c3f04e8e9b62.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 degree view of a spacious apartment with a modern kitchen and living area with fireplace.",
        "public_id": "019cfb54-cab8-715d-988b-c3f04e8e9b62",
        "storage_key": "property/6767906449167051/019cfb54-cab8-715d-988b-c3f04e8e9b62.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Scissortail Crossing Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=5f478e9bd25e9a53a514351b"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-583c-7059-8fb5-f039cc3a1dc5",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "scissortail-crossing",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051"
    },
    {
      "lead_collector_id": "019cf79e-58ad-76bd-9eb2-9b8ec34076db",
      "lead_source": "LANDING_PAGE",
      "name": "scissortail-crossing",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-broken-arrow-ok-scissortail-crossing",
      "search_query": "pet friendly apartments Broken Arrow OK",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Broken Arrow, OK",
      "h2_subtitle": "Discover pet friendly apartments in Broken Arrow, OK, at Scissortail Crossing. Perfect for you and your furry friends with our spacious courtyards.",
      "page_copy": "Welcome to Scissortail Crossing, where you’ll find the best pet friendly apartments Broken Arrow, OK has to offer. Our community is designed with pet lovers in mind, featuring charming courtyards complete with convenient pet stations, making it enjoyable for both you and your furry companions. Our spacious layouts provide ample room for everyone in your household, both two and four-legged.\n\nBeyond our pet-friendly environment, Scissortail Crossing offers residents an array of amenities to enhance every lifestyle. From the Resident Clubhouse perfect for gatherings to preinstalled WiFi modems powered by Cox, convenience is at your fingertips. Washer & dryer connections in each unit make laundry day a breeze, and cable-ready setups ensure you don’t miss a moment of your favorite shows. Experience a community where pets are not just allowed, but celebrated, in the heart of Broken Arrow, OK.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments - Broken Arrow, OK",
      "seo_description": "Find pet friendly apartments in Broken Arrow, OK at Scissortail Crossing, featuring courtyards with pet stations and more.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "generator",
      "page_item_url": "apartments-with-pool-wagoner-county-scissortail-crossing",
      "search_query": "apartments with pool Wagoner County",
      "category": "Amenity",
      "h1_title": "Apartments with Amenities in Wagoner County",
      "h2_subtitle": "Explore top apartments with pool alternatives in Wagoner County. Scissortail Crossing offers remarkable amenities for all its residents.",
      "page_copy": "Scissortail Crossing brings you top-tier apartments with amenities in Wagoner County, offering a lifestyle full of comfort and convenience. While we focus on providing exceptional community enhancements like our Resident Clubhouse and modern technology aids, there are excellent local pool options nearby for our residents to enjoy. Our location makes it easy to indulge in aquatic activities outside your home.\n\nIn addition to nearby pool facilities, Scissortail Crossing proudly offers a plethora of in-home and community advantages. From the washer & dryer connections that simplify your domestic routine to our preinstalled WiFi modems powered by Cox, every detail is curated for ease. Our beautiful courtyards with pet stations and cable-ready apartments make Scissortail Crossing an ideal choice for those seeking a well-rounded lifestyle in Wagoner County, OK.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Amenities - Wagoner County",
      "seo_description": "Discover Scissortail Crossing in Wagoner County, offering amenities and access to nearby pool facilities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "generator",
      "page_item_url": "broken-arrow-ok-apartments-air-conditioning-scissortail-crossing",
      "search_query": "Broken Arrow OK apartments with air conditioning",
      "category": "Amenity",
      "h1_title": "Broken Arrow Apartments with Comfort Features",
      "h2_subtitle": "Find Broken Arrow, OK apartments with modern comforts at Scissortail Crossing. Our homes offer exceptional conveniences for all lifestyles.",
      "page_copy": "At Scissortail Crossing, experience the best of Broken Arrow, OK living with stylish apartments offering exceptional comfort features. While air conditioning enhances our community, we up the ante by providing preinstalled WiFi modems powered by Cox, making staying connected a breeze.\n\nOur homes come equipped with washer & dryer connections and are cable ready, ensuring an easy transition and immediate access to all your must-have services. Nestled in scenic courtyards with pet stations, Scissortail Crossing caters equally to residents and their furry friends. Plus, our Resident Clubhouse offers the perfect setting for relaxation or socializing, making our community a standout choice in Broken Arrow, OK.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Broken Arrow Apartments with Comfort Features",
      "seo_description": "Explore Scissortail Crossing in Broken Arrow, OK, for apartments with air conditioning and modern comforts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "generator",
      "page_item_url": "scissortail-crossing-apartments-with-dog-park",
      "search_query": "Scissortail Crossing apartments with dog park",
      "category": "Amenity",
      "h1_title": "Scissortail Crossing Apartments with Pet Amenities",
      "h2_subtitle": "Discover exceptional pet-friendly living at Scissortail Crossing apartments. While a dog park is not on-site, explore nearby options for your pets.",
      "page_copy": "Welcome to Scissortail Crossing, where we offer more than just a home. Our apartments are designed with pet lovers in mind, providing thoughtful amenities that make life with pets enjoyable. While we don't feature an on-site dog park, Broken Arrow, OK offers several nearby alternatives perfect for your furry friends.\n\nScissortail Crossing is dedicated to pet-friendly living, featuring attractive courtyards with conveniently located pet stations. Our community boasts a range of other benefits too, like preinstalled WiFi modems powered by Cox, ensuring seamless connectivity. Enjoy in-home conveniences such as washer & dryer connections and cable-ready setups. The Resident Clubhouse is an ideal spot for relaxation and social gatherings. Experience the Scissortail Crossing difference, where comfort and pet-friendly amenities come together harmoniously.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Scissortail Crossing: Pet-Friendly Apartments",
      "seo_description": "Explore Scissortail Crossing for pet-friendly living in Broken Arrow, featuring courtyards and nearby dog park options.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "generator",
      "page_item_url": "24-hour-fitness-center-apartments-broken-arrow",
      "search_query": "24-hour fitness center apartments Broken Arrow",
      "category": "Amenity",
      "h1_title": "Convenience Meets Comfort in Broken Arrow",
      "h2_subtitle": "Looking for 24-hour fitness center apartments in Broken Arrow? Scissortail Crossing offers a range of convenient amenities.",
      "page_copy": "Although Scissortail Crossing focuses on providing a convenient lifestyle with amenities such as washer & dryer connections and high-speed internet, we understand the importance of fitness in your lifestyle. While we do not have a 24-hour fitness center on-site, our location in Broken Arrow provides easy access to nearby fitness facilities that cater to all your wellness needs.\n\nOur residents enjoy beautifully maintained courtyards with pet stations, a Resident Clubhouse perfect for gathering with friends, and cable-ready homes ready for entertainment. Scissortail Crossing is the perfect starting point for residents looking to balance relaxation and fitness with desired conveniences right in the heart of Broken Arrow, OK.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Comfortable Living in Broken Arrow",
      "seo_description": "Discover convenient living with fitness options near Scissortail Crossing in Broken Arrow.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-near-74014-scissortail-crossing",
      "search_query": "one bedroom apartments near 74014",
      "category": "Floorplan",
      "h1_title": "One-Bedroom Apartments Near 74014",
      "h2_subtitle": "Searching for one-bedroom apartments near 74014? Discover comfortable living at Scissortail Crossing, conveniently located in Broken Arrow, OK.",
      "page_copy": "Scissortail Crossing offers an inviting selection of one-bedroom apartments near the 74014 area. Our community in Broken Arrow provides residents with a balance of comfort and convenience. Each unit features washer & dryer connections, and they are cable ready, making setting up your new home a breeze.\n\nResidents enjoy enhanced connectivity with preinstalled WiFi modems powered by Cox, ideal for remote work or entertainment. The landscaped courtyards equipped with pet stations make our community exceptionally pet-friendly, and the Resident Clubhouse is perfect for socializing. Scissortail Crossing ensures a seamless living experience in the desirable Broken Arrow neighborhood.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One-Bedroom Apartments Near 74014",
      "seo_description": "Find cozy one-bedroom apartments near 74014 at Scissortail Crossing. Enjoy convenience and community living in Broken Arrow, OK.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-wagoner-county",
      "search_query": "two bedroom apartments Wagoner County",
      "category": "Floorplan",
      "h1_title": "Two-Bedroom Apartments in Wagoner County",
      "h2_subtitle": "Explore two-bedroom apartments at Scissortail Crossing in Wagoner County, offering modern comforts and essential amenities.",
      "page_copy": "At Scissortail Crossing, we offer spacious two-bedroom apartments in the heart of Wagoner County. Our community ensures a comfortable and convenient living environment, located in the serene setting of Broken Arrow, OK. Each apartment is thoughtfully designed with features such as washer & dryer connections, making daily chores more manageable.\n\nResidents enjoy access to a variety of amenities, including preinstalled WiFi modems powered by Cox for seamless internet connectivity, and cable-ready units for great entertainment options. Our courtyards feature pet stations, creating a welcoming space for pet owners, and the Resident Clubhouse serves as a vibrant hub for community life. Discover the ideal blend of comfort and convenience at Scissortail Crossing.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two-Bedroom Apartments Wagoner County",
      "seo_description": "Discover spacious two-bedroom apartments at Scissortail Crossing in Wagoner County, offering community and convenience in Broken Arrow, OK.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "generator",
      "page_item_url": "apartments-near-tulsa-community-college-southeast-campus",
      "search_query": "apartments near Tulsa Community College Southeast Campus OK",
      "category": "School",
      "h1_title": "Apartments Near Tulsa Community College",
      "h2_subtitle": "Discover Scissortail Crossing near Tulsa Community College Southeast Campus. Offering convenience and quality in Broken Arrow, OK.",
      "page_copy": "Welcome to Scissortail Crossing, ideally located for students and faculty seeking apartments near the Tulsa Community College Southeast Campus in OK. Our community, situated in the heart of Broken Arrow, provides a range of amenities designed for a modern lifestyle.\n\nScissortail Crossing ensures seamless Internet access with preinstalled WiFi modems powered by Cox, perfect for online courses and streaming. Enjoy the benefits of cable-ready homes and in-home washer & dryer connections. Our pet-friendly atmosphere features courtyards with pet stations, and the Resident Clubhouse offers a great space to unwind or study with peers. Experience student-friendly living just minutes away from campus.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tulsa Community College Southeast",
      "seo_description": "Live near Tulsa Community College Southeast Campus at Scissortail Crossing. Enjoy convenience in Broken Arrow, OK.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "generator",
      "page_item_url": "scissortail-crossing-apartments-near-nsu-broken-arrow",
      "search_query": "Scissortail Crossing apartments near Northeastern State University Broken Arrow",
      "category": "School",
      "h1_title": "Scissortail Crossing Apartments Near NSU",
      "h2_subtitle": "Explore Scissortail Crossing apartments just a stone's throw from Northeastern State University in Broken Arrow, OK.",
      "page_copy": "Scissortail Crossing offers a prime location for students, faculty, and staff looking for apartments near Northeastern State University's Broken Arrow campus. Our community combines modern living with the convenience of being close to NSU, making daily commutes a breeze.\n\nOur apartments come equipped with essential comforts such as preinstalled WiFi modems powered by Cox, enhancing connectivity for educational needs. Each unit allows easy living with washer & dryer connections and is cable ready. Enjoy scenic courtyards complete with pet stations and socialize in our welcoming Resident Clubhouse. At Scissortail Crossing, you'll find an optimal blend of homely comfort and accessibility to NSU and other local amenities.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Scissortail Crossing Apts Near NSU",
      "seo_description": "Find Scissortail Crossing apartments near Northeastern State University in Broken Arrow, offering comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "generator",
      "page_item_url": "apartments-near-council-oak-healthcare-broken-arrow",
      "search_query": "apartments near Council Oak Comprehensive Healthcare Broken Arrow",
      "category": "Hospital",
      "h1_title": "Apartments Near Council Oak Healthcare",
      "h2_subtitle": "Discover Scissortail Crossing, conveniently located near Council Oak Comprehensive Healthcare in Broken Arrow, OK.",
      "page_copy": "Scissortail Crossing presents a strategic choice for those seeking apartments near Council Oak Comprehensive Healthcare in Broken Arrow. Our community provides unmatched convenience for healthcare professionals and patients alike, ensuring easy access to work and essential services.\n\nOur apartments are equipped with modern comforts, featuring preinstalled WiFi modems powered by Cox, making seamless connectivity a part of everyday life. Residents appreciate the practicality of in-home washer & dryer connections and cable-ready units. The serene courtyards, complete with pet stations, and a vibrant Resident Clubhouse enhance the community spirit. Experience a comfortable and connected lifestyle at Scissortail Crossing, right by Council Oak Healthcare.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Council Oak Healthcare Broken Arrow",
      "seo_description": "Live at Scissortail Crossing near Council Oak Healthcare in Broken Arrow, offering comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "generator",
      "page_item_url": "apartments-close-to-ascension-st-john-broken-arrow",
      "search_query": "apartments close to Ascension St. John Broken Arrow Wagoner County",
      "category": "Hospital",
      "h1_title": "Apartments Close to Ascension St. John",
      "h2_subtitle": "Scissortail Crossing offers ideal living close to Ascension St. John Broken Arrow in Wagoner County, OK.",
      "page_copy": "For those seeking apartments close to Ascension St. John Broken Arrow in Wagoner County, Scissortail Crossing stands out as the perfect choice. Located conveniently, our community supports medical professionals and patients who desire quick access to healthcare services.\n\nScissortail Crossing combines convenience with comfort, offering amenities like preinstalled WiFi modems powered by Cox for uninterrupted connectivity. Each unit is fitted with washer & dryer connections and is cable ready, ensuring a hassle-free living experience. The pet-friendly environment includes courtyards with pet stations, while our Resident Clubhouse provides a communal space for relaxation and gathering. Make Scissortail Crossing your home close to Ascension St. John.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Ascension St. John Broken Arrow",
      "seo_description": "Discover Scissortail Crossing, offering apartments near Ascension St. John Broken Arrow in Wagoner County, OK.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "generator",
      "page_item_url": "apartments-near-rhema-park-broken-arrow",
      "search_query": "apartments near Rhema Park Broken Arrow",
      "category": "Park",
      "h1_title": "Apartments Near Rhema Park",
      "h2_subtitle": "Find your ideal home at Scissortail Crossing, located near the peaceful Rhema Park in Broken Arrow, OK.",
      "page_copy": "Living near Rhema Park in Broken Arrow comes with a blend of tranquility and convenience, and Scissortail Crossing is ideally situated to provide just that. Our apartments offer residents quick access to the lush greenery and recreational spaces of Rhema Park.\n\nOur community combines comfort and ease with features such as preinstalled WiFi modems powered by Cox, facilitating a seamless online experience. Residents enjoy in-home washer & dryer connections and cable-ready units, making everyday living more manageable. Enjoy leisure time in our courtyards equipped with pet stations or connect with neighbors in the inviting Resident Clubhouse. Discover the perfect balance of nature and modern living at Scissortail Crossing.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Rhema Park Broken Arrow",
      "seo_description": "Live close to Rhema Park at Scissortail Crossing in Broken Arrow, offering accessible and comfortable apartment living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "generator",
      "page_item_url": "apartments-close-to-elam-park-ok",
      "search_query": "apartments close to Elam Park OK",
      "category": "Park",
      "h1_title": "Apartments Close to Elam Park",
      "h2_subtitle": "Explore living at Scissortail Crossing, conveniently close to Elam Park, OK, where nature and comfort meet.",
      "page_copy": "Situated near the inviting Elam Park, Scissortail Crossing offers an ideal living environment for those looking to enjoy both nature and modern comforts. Our community provides easy access to Elam Park’s recreational opportunities, perfect for outdoor enthusiasts.\n\nExperience the advantages of contemporary living with our preinstalled WiFi modems powered by Cox. Each apartment features washer & dryer connections and is cable ready, ensuring seamless daily living. Residents can also enjoy our pet-friendly courtyards, complete with pet stations, and the Resident Clubhouse, which fosters a strong sense of community. Scissortail Crossing is your gateway to a balanced lifestyle, providing both relaxation and convenience near Elam Park, OK.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Elam Park OK",
      "seo_description": "Find convenient living at Scissortail Crossing, close to Elam Park, OK, combining modern amenities with a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "generator",
      "page_item_url": "apartments-near-jackson-park-74014",
      "search_query": "apartments near Jackson Park 74014",
      "category": "Park",
      "h1_title": "Apartments Near Jackson Park",
      "h2_subtitle": "Discover Scissortail Crossing, located near the serene Jackson Park, 74014, where you can enjoy both comfort and nature.",
      "page_copy": "Nestled close to the beautiful Jackson Park in the 74014 area, Scissortail Crossing offers the perfect apartments for those seeking a blend of convenience and relaxation. Living near Jackson Park means easy access to its walking trails and recreational facilities, ideal for outdoor enthusiasts.\n\nScissortail Crossing enhances your lifestyle with modern amenities such as preinstalled WiFi modems powered by Cox, ensuring constant connectivity. Each apartment is equipped with washer & dryer connections and is cable ready, enhancing everyday convenience. Enjoy pet-friendly courtyards complete with pet stations, and socialize at the Resident Clubhouse. Embrace the best of both worlds with Scissortail Crossing's prime location near Jackson Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Jackson Park 74014",
      "seo_description": "Live near Jackson Park at Scissortail Crossing, 74014, offering modern amenities and a prime location for relaxation and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167051",
      "source": "generator",
      "page_item_url": "apartments-close-to-nienhuis-park-wagoner-county",
      "search_query": "apartments close to Nienhuis Park Wagoner County",
      "category": "Park",
      "h1_title": "Apartments Close to Nienhuis Park",
      "h2_subtitle": "Explore Scissortail Crossing, conveniently located near Nienhuis Park in Wagoner County, where comfort and community await.",
      "page_copy": "Scissortail Crossing offers exceptional living close to Nienhuis Park in Wagoner County, where you can appreciate natural beauty and community amenities. Our apartments provide residents with immediate access to the recreational opportunities at Nienhuis Park, making it an ideal spot for relaxation and outdoor activities.\n\nEquipped with modern conveniences, Scissortail Crossing features preinstalled WiFi modems powered by Cox, facilitating hassle-free online connectivity. Our apartments come cable ready and include washer & dryer connections, enhancing your lifestyle. Residents can enjoy strolls with their pets in our courtyards, equipped with convenient pet stations, and build connections at the Resident Clubhouse. Experience an unparalleled lifestyle near Nienhuis Park with Scissortail Crossing.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Nienhuis Park Wagoner County",
      "seo_description": "Discover Scissortail Crossing near Nienhuis Park, Wagoner County, combining comfortable living with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5210"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-C6DV0FS3XQ"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151607"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/scissortail-crossing/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-THWTX5ZB"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449167051/019d1bd9-916d-713a-9d8c-221b71436dfa.pdf"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "9c8138c0-2e8e-47f3-973b-831ca0db587f"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "833-654-0998"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "64651da151ae55922104e085"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkVyYkRoRWFacFhnVGpSMUFDWGlQVXc9PSIsInZhbHVlIjoiT3E0bzBuUFlvck9YWUZRYlRQMGZ6UT09IiwibWFjIjoiZmM3ZGUzZWQ2MjJiYzRlZDUyNjU2NGMwZTgwYmFkY2Y3MWQ2NGQwYWI4OTQ5MGExYTQwZGJlYjQ5MTEwMjY3OCJ9"
    }
  ],
  "custom_qb_id": "5210",
  "custom_ga4_id": "G-C6DV0FS3XQ",
  "custom_repli_id": "10041151607",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/scissortail-crossing/register/",
  "custom_google_gtm_id": "GTM-THWTX5ZB",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449167051/019d1bd9-916d-713a-9d8c-221b71436dfa.pdf",
  "custom_rentgrata_property_id": "9c8138c0-2e8e-47f3-973b-831ca0db587f",
  "custom_ppc_tracking_phone_number": "833-654-0998",
  "custom_residentboost_apartment_id": "64651da151ae55922104e085",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkVyYkRoRWFacFhnVGpSMUFDWGlQVXc9PSIsInZhbHVlIjoiT3E0bzBuUFlvck9YWUZRYlRQMGZ6UT09IiwibWFjIjoiZmM3ZGUzZWQ2MjJiYzRlZDUyNjU2NGMwZTgwYmFkY2Y3MWQ2NGQwYWI4OTQ5MGExYTQwZGJlYjQ5MTEwMjY3OCJ9"
};

export const generatedAt = '2026-08-27T21:32:36.146Z';
